import React from 'react'
import { MobileToggle, ToggleButton } from './styled'
import { ListMobile, Map } from '../../assets/icons'

const MobileViewToggle = ({ showMap, onToggle, overlay }) => (
	<MobileToggle $overlay={overlay}>
		{showMap ? (
			<ToggleButton onClick={() => onToggle(false)}>
				<ListMobile />
				Lista
			</ToggleButton>
		) : (
			<ToggleButton onClick={() => onToggle(true)}>
				<Map />
				Mapa
			</ToggleButton>
		)}
	</MobileToggle>
)

export default MobileViewToggle
